var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75,3H16V.75A.76.76,0,0,0,15.25,0h-8A.76.76,0,0,0,6.5.75V3H.75a.75.75,0,0,0,0,1.5H2.5V23.75a.76.76,0,0,0,.75.75h16a.76.76,0,0,0,.75-.75V4.5h2.75a.75.75,0,0,0,0-1.5ZM8,1.5h6.5V3H8ZM18.5,23H4V4.5H18.5ZM8,7.25v12a.75.75,0,0,1-1.5,0v-12a.75.75,0,0,1,1.5,0Zm4,0v12a.75.75,0,0,1-1.5,0v-12a.75.75,0,0,1,1.5,0Zm3.25-.75a.76.76,0,0,1,.75.75v12a.75.75,0,0,1-1.5,0v-12A.76.76,0,0,1,15.25,6.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b9fb00317e206bcec671e91c36c3286f.svg";
export { ForwardRef as ReactComponent };